module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"abort-message":"O upload está sendo interrompido...","close":"Fechar","continue":"Continuar","errors-occurred":"Encontramos erros","stop":"Parar","try-again":"Tentar novamente","uploading-title":"Enviando mídias","uploaded-items":"mídia(s) enviada(s)","view-skipped":"Ver detalhes"}}')
  delete Component.options._Ctor
}
